import App from './App.svelte';
const app = new App({
    target: document.querySelector('#wkt-seo-calculator'),
});
export default app;
